import React, { useContext, useEffect } from 'react';
import TableApp from '../../../components/AccountMenu/components/table/Table';
import { columns } from '../../util/index';
import { Header, Segment } from 'semantic-ui-react';
import ReconJob from '../reconJob/index';
import CreateShipmentModal from './createShipmentModal';
import Button from '../../../components/AccountMenu/components/button/Button';
import { useSelector, useDispatch } from 'react-redux';
import { getReconjobsPayload } from '../../api/apiPayloads';
import { ReconGlobalContext } from '../providers/ReconGlobalProvider';
import { initializeReconShipments } from '../../slices/reconShipmentsSlice';
import useApiHouse from '../../api/useApiHouse';
import { initalizeCurrentJob } from '../../slices/currentJobSlice';

const ShipmentsTable = ({createBtnClass=""}) => {
  const [show, setShow] = React.useState(false);
  const [isModal, setIsModal] = React.useState(false);

  const {kxUser} = useContext(ReconGlobalContext);
  const [getReconShipments, {data: reconShipmentsData, error, isLoading: getReconShipmentsLoader}] = useApiHouse();
  const {userBasicInfo: {userGuid = ""} = {}, userInfo: {brokerAdditionalInfo: {filerCode = "", portCode=""} = {}} = {}} = kxUser
  const {kxUser: {channelConnections: {customersConnected:importerList=[]}={}}} = useContext(ReconGlobalContext);
  useEffect(() => {
    getReconShipments(getReconjobsPayload(userGuid));
  },[])

  const {reconShipments} = useSelector((state) => state.reconShipments);

  const dispatch = useDispatch();
  useEffect(() => {
    if(getReconShipmentsLoader){
      dispatch(initializeReconShipments([{reconShipmentStatus: "please Wait..."}]))
    }
    if(!getReconShipmentsLoader && reconShipmentsData){
      let { reconShipments } = reconShipmentsData.eventMessage;
      if(Object.keys(reconShipmentsData.eventMessage).length === 0){
        reconShipments = [];
      }
      dispatch(initializeReconShipments(reconShipments))
    }
    if(!getReconShipmentsLoader && error){
      dispatch(initializeReconShipments([{reconShipmentStatus: "Please try", statusUpdateTime: "again later"}]))
    }
  }, [reconShipmentsData, getReconShipmentsLoader, error])

  const showModal = () => {
    setIsModal(true);
  };

  const rowOnClickMethod = (values, id) => {
    dispatch(initalizeCurrentJob(values));
    setShow(true);
  };
  if (show) {
    return <ReconJob />;
  }
  return (
    <>
      {isModal && (
        <CreateShipmentModal userGuid={userGuid} filerCode={filerCode} processingPort={portCode} isModal={isModal} setIsModal={setIsModal} />
      )}

      <div className='recon-table'>
          <span className='header-span'>
            <Header as='h1' className='header'></Header>
            <Button
              className={`${createBtnClass}`}
              onClick={showModal}
              type='button'
            >
              CREATE
            </Button>
          </span>
            
            <div className='table-app'>
              <TableApp
                columns={columns}
                importerList={importerList}
                data={reconShipments}
                method={rowOnClickMethod}
                selectedRowId={''}
                pageNumberMethod={() => {}}
                pageNumber={1}
                totalPages={1}
                searchMethod={() => {}}
                manualPagination={false}
                reconCheck={true}
              />
            </div>
      </div>
    </>
  );
};

export default ShipmentsTable;
